import { render, staticRenderFns } from "./ManageStory.vue?vue&type=template&id=2ee28e5f"
import script from "./ManageStory.vue?vue&type=script&lang=js"
export * from "./ManageStory.vue?vue&type=script&lang=js"
import style0 from "./ManageStory.vue?vue&type=style&index=0&id=2ee28e5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports